import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ActionsModule } from '../shared/actions/actions.module';
import { CodeExchangeModule } from '../shared/code-exchange/code-exchange.module';
import { StatusBannerModule } from '../shared/status-banner/status-banner.module';
import { ImageCompressModule } from '../shared/utils/image-compress.module';
import { IdentityActionSheetComponent } from './identity-action-sheet/identity-action-sheet.component';
import { IdentityCheckComponent } from './identity-check/identity-check.component';
import { IdentityLaunchComponent } from './identity-launch/identity-launch.component';
import { IdentityLicenseUploadActionSheetComponent } from './identity-license-upload-action-sheet/identity-license-upload-action-sheet.component';
import { IdentityStartComponent } from './identity-start/identity-start.component';
import { LicenseStatusComponent } from './license-status/license-status.component';
import { LicenseUploadComponent } from './license-upload/license-upload.component';
@NgModule({
  declarations: [
    IdentityCheckComponent,
    LicenseStatusComponent,
    IdentityStartComponent,
    IdentityLaunchComponent,
    IdentityActionSheetComponent,
    IdentityLicenseUploadActionSheetComponent,
    LicenseUploadComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    /* WebcamModule, */
    ActionsModule,
    StatusBannerModule,
    /* BerbixModule, */
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    CodeExchangeModule,
    ImageCropperComponent,
    ImageCompressModule
  ]
})
export class IdentityCheckModule { }

export { IdentityCheckComponent } from './identity-check/identity-check.component';

